module.exports = {
  RETRIEVE_OUTBOUND_MRD_POSTAL_OPERATOR_REQUEST: 'RETRIEVE_OUTBOUND_MRD_POSTAL_OPERATOR_REQUEST',
  RETRIEVE_OUTBOUND_MRD_POSTAL_OPERATOR_SUCCESS: 'RETRIEVE_OUTBOUND_MRD_POSTAL_OPERATOR_SUCCESS',
  RETRIEVE_OUTBOUND_MRD_POSTAL_OPERATOR_FAILURE: 'RETRIEVE_OUTBOUND_MRD_POSTAL_OPERATOR_FAILURE',
  DEPARTURE_MRD_MAIL_PROCESSING_CENTER_CHECKED: 'DEPARTURE_MRD_MAIL_PROCESSING_CENTER_CHECKED',
  DEPARTURE_MRD_POSTAL_OPERATOR_EXPANDED: 'DEPARTURE_MRD_POSTAL_OPERATOR_EXPANDED',
  SELECT_ALL_DEPARTURE_MRD_MAIL_PROCESSING_CENTERS: 'SELECT_ALL_DEPARTURE_MRD_MAIL_PROCESSING_CENTERS',
  DESELECT_ALL_DEPARTURE_MRD_MAIL_PROCESSING_CENTERS: 'DESELECT_ALL_DEPARTURE_MRD_MAIL_PROCESSING_CENTERS',
  DEPARTURE_MRD_POSTAL_OPERATOR_EXPANDED_ADMIN: 'DEPARTURE_MRD_POSTAL_OPERATOR_EXPANDED_ADMIN',
};
